"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateLastVisitedOrgsCache = exports.setLastVisitedOrgsCache = exports.getLastVisitedOrgsCache = void 0;

var tslib_1 = require("tslib");

var storageKeyForOrgsCache = 'lastVisitedOrganization';

function getLastVisitedOrgsCache() {
  var currentLastVisitedOrganizations;

  try {
    currentLastVisitedOrganizations = JSON.parse(localStorage.getItem(storageKeyForOrgsCache) || '{}');
  } catch (_a) {
    currentLastVisitedOrganizations = {};
  }

  return currentLastVisitedOrganizations;
}

exports.getLastVisitedOrgsCache = getLastVisitedOrgsCache;

function setLastVisitedOrgsCache(newVisitedOrgsCache) {
  localStorage.setItem(storageKeyForOrgsCache, JSON.stringify(newVisitedOrgsCache));
}

exports.setLastVisitedOrgsCache = setLastVisitedOrgsCache;

function updateLastVisitedOrgsCache(userId, orgId) {
  var _a;

  setLastVisitedOrgsCache((0, tslib_1.__assign)((0, tslib_1.__assign)({}, getLastVisitedOrgsCache()), (_a = {}, _a[userId] = orgId, _a)));
}

exports.updateLastVisitedOrgsCache = updateLastVisitedOrgsCache;